// One registry for the standalone audience navigation and its future main-nav slot.
export const audiences = [
  { slug: 'builders', label: 'Builders', intent: 'Keep the whole build.', image: 'builders' },
  {
    slug: 'organizers',
    label: 'Organizers',
    intent: 'Carry the show beyond the gates.',
    image: 'organizers',
  },
  { slug: 'clubs', label: 'Clubs', intent: 'Give your people a place.', image: 'clubs' },
  { slug: 'shops', label: 'Shops', intent: 'Put your name on the work.', image: 'workshop' },
] as const;
